import { render, staticRenderFns } from "./InstagramFeed.vue?vue&type=template&id=985b17be&"
import script from "./InstagramFeed.vue?vue&type=script&lang=js&"
export * from "./InstagramFeed.vue?vue&type=script&lang=js&"
import style0 from "./InstagramFeed.vue?vue&type=style&index=0&id=985b17be&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppSliceLoader: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppSliceLoader.vue').default,AppContainer: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppContainer.vue').default})
